import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { TESTING_REPORTS } from './route-names'

export default (): RouteRecordRaw[] => {
  const config = useRuntimeConfig()

  // TODO(testing-reports): register the route in every environment once the
  // upstream testing-reports service exists and enforces the Quality/Pricing
  // authorization server-side.
  if (config.public.ENVIRONMENT === 'prod') return []

  return [
    {
      path: 'testing-reports/:formattedReportId',
      name: TESTING_REPORTS.REPORT,
      component: () =>
        import('~/scopes/testing-reports/pages/TestingReport/TestingReport.vue'),
      meta: {
        owners: ['bot-squad-quality-and-pricing'],
        // TODO(testing-reports): restore `auth: { mode: ['authenticated'] }`
        // once the upstream testing-reports service exists and enforces the
        // Quality/Pricing authorization server-side. Temporarily public so the
        // page can be reviewed locally against the mock server endpoint.
        layout: false,
        shoppingAssistant: { enabled: false },
      },
    },
  ]
}
